module.exports = __webpack_public_path__ + "img/defaultavatar3.723158d9.png";